module.exports = __webpack_public_path__ + "img/LONGTENG.56d415c3.png";